import React, { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import MenuItem, { MenuItemBaseProps } from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuItem';

import { trackButtonClicked } from '../../../Services/Analytics/TrackEventsService';

type TrackedMenuItemProps = MenuItemBaseProps & {
  onClick?: () => void;
  trackingName?: string;
  trackingProperties?: unknown;
};

const TrackedMenuItem: React.FC<TrackedMenuItemProps> = forwardRef(
  ({ onClick, trackingName, trackingProperties, ...rest }, ref) => {
    const dispatch = useDispatch();
    const onTrackedMenuItemClick = () => {
      dispatch(trackButtonClicked(trackingName, trackingProperties));
      if (onClick) onClick();
    };

    return <MenuItem onClick={onTrackedMenuItemClick} ref={ref} {...rest} />;
  }
);

export default TrackedMenuItem;
